const selectors = {
    productContainer: document.querySelector('.product-details-wrapper'),
    productMedia: document.querySelector('[data-productMedia]'),
    zoomBtns: document.querySelectorAll('[data-productZoom]')
  };

  const mediaJSON = JSON.parse(selectors.productMedia.innerHTML);
  window.productMedia = mediaJSON;
  class TemplateProductJS {
    constructor() {
      // Custom code for product page goes here

      selectors.zoomBtns.forEach((btn)=>{
        btn.addEventListener('click', (event)=>{
            let currentTarget = event.target;
            this.manageZoom(currentTarget);
        })
    });
    window.addEventListener('load', (event) => {
        if (window.innerWidth <= 991) {
          let relaProduct = document.querySelector('.block-append');
          if(relaProduct != undefined){
            document.querySelector('#MainContent').appendChild(relaProduct);
          }
        }
      });
    }

    manageZoom(currentTarget){
      let currentSlide = currentTarget.closest('.product--media');
      let currentSlideIndex = 1;
      if(currentSlide) currentSlideIndex = Array.from(currentSlide.parentNode.children).indexOf(currentSlide);
      
      let zoomSlider = '';
      window.productMedia.forEach(i => {
          if(i.media_type == "external_video"){
              zoomSlider += `<div class="swiper-slide carousel-cell d-flex align-items-center justify-content-center zoom--product-image" data-mediaID="${i.id}" role="treeitem">
                  <div class="custom-video-container">
                      <custom-video class="placement--grid" data-video-type="${i.host}" data-video-id="${i.external_id}" data-placement="grid" data-autoplay="true" data-controls="true">
                          <div class="cta-btn" data-aos="hero">
                              <button class="play__button btn btn-primary" data-trigger-video aria-label="Play Video">
                                  <span class="icon-play text-body"></span>
                              </button>
                              <button class="pause__button btn btn-primary" data-pause-video aria-label="Pause Video">
                                  <span class="icon-pause"></span>
                              </button>
                          </div>
                          <div class="content-section">
                              <div class="poster-image">
                                  <img class="img-fluid"
                                  src="${i.preview_image.src}"
                                  alt="${i.alt}"
                                  />
                              </div>
                          </div>
                          <div class="video-section" tabindex="0"></div>
                      </custom-video>
                  </div>
              </div>`;
          }else if(i.media_type == "video"){
              zoomSlider += `<div class="swiper-slide carousel-cell d-flex align-items-center product--media" data-mediaID="${i.id}" role="treeitem">
                  <div class="custom-video-container">
                      <custom-video class="placement--grid" data-video-type="local" data-video-id="${i.sources[0].url}" data-placement="grid" data-autoplay="true" data-controls="true">
                          <div class="cta-btn">
                              <button class="play__button btn btn-primary" data-trigger-video aria-label="Play Video">
                                  <span class="icon-play text-body"></span>
                              </button>
                              <button class="pause__button btn btn-primary" data-pause-video aria-label="Pause Video">
                                  <span class="icon-pause"></span>
                              </button>
                          </div>
                          <div class="content-section">
                              <div class="poster-image">
                                  <img class="img-fluid"
                                  src="${i.preview_image.src}"
                                  alt="${i.alt}"/>
                              </div>
                          </div>
                          <div class="video-section" tabindex="0"></div>
                      </custom-video>
                  </div>
              </div>`;
          }else if(i.media_type == "image"){
              zoomSlider+= `<div class="swiper-slide carousel-cell d-flex align-items-center justify-content-center zoom--product-image" data-mediaID="${i.id}" role="treeitem">
                  <img class="img-fluid"
                  src="${i.preview_image.src}&width=600"
                  srcset="
                    ${i.preview_image.src}&width=900 992w"
                  alt="${i.alt}"
                  width="${i.preview_image.width}"
                  height="${i.preview_image.height}"
                  sizes="(min-width: 1200px) 1000px, (min-width: 992px) 900px, 600px"
                  loading="lazy"
                  />
              </div>`;
          }
      });
      let finalHTML = `<slider-element class="swiper-container zoom-slider position-relative carousel container">
          <div class="swiper swiper-slider zoom--product-images"
              data-slider='{
                      "loop": false,
                      "observer": true,
                      "observeParents": true,
                      "slidesPerView": "1",
                      "spaceBetween": 15,
                      "grabCursor": true,
                      "navigation": {
                          "nextEl": ".zoom-next",
                          "prevEl": ".zoom-prev"
                      }
                  }' role="tree">
              <div class="swiper-wrapper" >${zoomSlider}</div>
          </div>
          <div class="swiper-button-prev zoom-prev icon-prev"></div>
          <div class="swiper-button-next zoom-next icon-next"></div>
      </slider-element>`;

      const zoomContainer = document.getElementById('PopupModal-zoom');
      if(zoomContainer){
          zoomContainer.querySelector('.modal-body').innerHTML = finalHTML;
          zoomContainer.show();
          if(productZoomSlider) productZoomSlider.slideTo(currentSlideIndex, 2000, true);
      }
  }
}

typeof TemplateProductJS !== 'undefined' && new TemplateProductJS();
